module.exports = __webpack_public_path__ + "fonts/YouSheBiaoTiHei-2.1726685c.ttf";